<template>
    <div class="list-item">
        <div class="legend">
            <p>{{ $t('dash.reporting.pdf.listItem.date') }}</p>
            <p>{{ $t('dash.reporting.pdf.listItem.type') }}</p>
            <p>{{ $t('dash.reporting.pdf.listItem.publication') }}</p>
            <p>{{ $t('dash.reporting.pdf.listItem.print') }}</p>
            <p>{{ $t('dash.reporting.pdf.listItem.comments') }}</p>
            <p>{{ $t('dash.reporting.pdf.listItem.shares') }}</p>
            <p>{{ $t('dash.reporting.pdf.listItem.reactions') }}</p>
            <p>{{ $t('dash.reporting.pdf.listItem.engagement') }}</p>
        </div>


        <div class="item" v-for="post in posts" :key="post.id">
            <p>{{ getFormatDate(post.created_time) }}</p>
            <div class="type-content"><div class="badge-type-post">{{ post.type == "snippet" ? "lien" : post.type }}</div></div>
            <div class="publication">
                <div class="picture">
                    <i v-if="post.type && post.type == 'NATIVE_DOCUMENT'"  class="fa-regular fa-file-pdf"></i>
                    <img v-else-if="post.attachment_url" :src="post.attachment_url">
                    <i v-else class="fa-regular fa-image-slash"></i>
                </div>
                <p>{{post.message}}</p>
            </div>
            <p class="impression number">{{ 'post_impressions' in post ? post.post_impressions  : 0 }}</p>
            <p class="comment number">{{ 'comments_count' in post ? post.comments_count : 0 }}</p>
            <p class="share number">{{ 'shares_count' in post ? post.shares_count : 0 }}</p>
            <p class="reaction number">{{ 'post_reactions_sum' in post ? post.post_reactions_sum : 'like_count' in post  ? post.like_count : ''}}</p>
            <p class="engagement number">{{ 'reach_engagement' in post ? post.reach_engagement.toFixed(2)+'%' : '' }}</p>
        </div>

        
        
    </div>
</template>

<script>
    export default {
        props: {
            posts: {
                type: Array,
                default: function() {
                    return []
                }
            },
        },

        methods: {
            getFormatDate(dateString) {
                return (new Date(dateString)).toLocaleString('fr-FR',{year: 'numeric', month: 'short', day: 'numeric'}) 
            }
        },
    }
</script>
